import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface Rendezvous {
  _id?: string;
  titre: string;
  date: string;
  description: string;
  parents: string[];
  heure: string;
  matiere?: string;
  administration: string;
  createdBy: string
}

export const rendezvousSlice = createApi({
  reducerPath: "Rendezvous",
  baseQuery: baseQueryWithAuth("rendez-vous"),
  tagTypes: ["Rendezvous"],
  endpoints(builder) {
    return {
      fetchRendezvous: builder.query<Rendezvous[], number | void>({
        query() {
          return `/getRendezvous`;
        },
        providesTags: ["Rendezvous"],
      }),
      fetchRendezvousByEnseignantId: builder.query<Rendezvous[], number | void>(
        {
          query: (_id) => ({
            url: `/rendezvous-enseignant-id/${_id}`,
            method: "GET",
          }),
          providesTags: ["Rendezvous"],
        }
      ),
      addRendezvous: builder.mutation<void, Rendezvous>({
        query(payload) {
          return {
            url: "/createRendezvous",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Rendezvous"],
      }),
      updateRendezvous: builder.mutation<void, Rendezvous>({
        query: ({ _id, ...rest }) => ({
          url: `/updateRendezvous/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["Rendezvous"],
      }),
      deleteRendezvous: builder.mutation<void, Rendezvous>({
        query: (_id) => ({
          url: `/deleteRendezvous/${_id}`,
          method: "Delete",
        }),
        invalidatesTags: ["Rendezvous"],
      }),
      bulkDeleteRendezvous: builder.mutation<{ deleted: number }, string[]>({
        query(ids) {
          return {
            url: "/bulkDelete",
            method: "POST",
            body: { ids },
          };
        },
        invalidatesTags: ["Rendezvous"],
      }),
    };
  },
});

export const {
  useAddRendezvousMutation,
  useFetchRendezvousByEnseignantIdQuery,
  useDeleteRendezvousMutation,
  useFetchRendezvousQuery,
  useUpdateRendezvousMutation,
  useBulkDeleteRendezvousMutation,
} = rendezvousSlice;
